import { useQueryClient } from '@tanstack/react-query'
import { getApi } from '@BUP/services/Axios'
import { useCourseAssignmentMutation } from './useCourseAssignmentMutation'

const openPeriod = async ({ grade, allowOtherCourses } = {}) => {
  const client = await getApi('schools', { authenticated: true, version: 5 })
  const { data } = await client.post('/current-organization/course-assignment/periods', { grade, allowOtherCourses })
  return data
}

export const useOpenPeriod = () => {
  const queryClient = useQueryClient()

  return useCourseAssignmentMutation({
    mutationFn: openPeriod,
    hookName: 'useOpenPeriod',
    errorMessage: 'Error opening course assignment period',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['courseAssignmentPeriodStatus'] })
      queryClient.invalidateQueries({ queryKey: ['courseAssignmentPeriods'] })
    }
  })
}
